<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 10">
    <path
        d="M2 5.2l3.6-3.77a.75.75 0 000-1.06.75.75 0 00-1.08.03L.4 4.71a.75.75 0 000 1.06l4.15 3.86a.73.73 0 00.51.21.75.75 0 00.52-1.3z" />
</svg>